"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, FileCheck, Tag } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Closingcta() {
  const shouldReduceMotion = useReducedMotion();
  const containerVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };
  return <section id="closingcta" data-nav="dark" className="relative bg-primary text-primary-foreground py-20 md:py-28 overflow-hidden">
      {/* Subtle Scandinavian decorative elements */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-5">
        <div className="absolute -top-24 -left-24 size-96 rounded-lg bg-secondary blur-3xl" />
        <div className="absolute -bottom-24 -right-24 size-96 rounded-lg bg-secondary blur-3xl" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.3
      }} variants={containerVariants} className="max-w-2xl mx-auto text-center flex flex-col items-center">
          {/* Main Title */}
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight mb-4">
            {"Prêt·e à vous lancer ?"}
          </h2>

          {/* Price reminder & promo block */}
          <div className="flex flex-col items-center gap-3 mb-8">
            <div className="inline-flex items-baseline gap-3">
              <span className="text-xl sm:text-2xl text-primary-foreground/60 line-through font-serif">
                {"39€"}
              </span>
              <span className="text-3xl sm:text-4xl md:text-5xl font-bold font-serif text-secondary">
                {"33,15€"}
              </span>
              <span className="text-xs sm:text-sm text-primary-foreground/75 uppercase tracking-wider">
                {"paiement unique"}
              </span>
            </div>

            <div className="inline-flex flex-wrap items-center justify-center gap-2 text-xs sm:text-sm bg-primary border border-secondary/40 text-primary-foreground px-4 py-1.5 rounded-md shadow-xs">
              <Tag className="size-3.5 text-secondary shrink-0" />
              <span>
                {"Code promo "}
                <span className="font-mono font-bold text-secondary tracking-wider">
                  {"OCTOBER15"}
                </span>
                {" (-15%)"}
              </span>
              <span className="text-primary-foreground/40 hidden sm:inline">{"•"}</span>
              <span className="text-primary-foreground/80">
                {"jusqu'au 31 octobre 2026"}
              </span>
            </div>
          </div>

          {/* CTA Button */}
          <div className="mb-6 w-full sm:w-auto">
            <Button asChild variant="secondary" size="lg" className="w-full sm:w-auto px-8 py-6 text-base font-medium rounded-md shadow-md hover:shadow-lg transition-all group">
              <Link to="https://payhip.com/b/xB6sv" target="_blank" rel="noopener noreferrer">
                <span>{"Je veux le guide"}</span>
                <ArrowRight className="size-4 ml-1 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>

          {/* Reassurance text */}
          <div className="flex items-center justify-center gap-2 text-sm text-primary-foreground/80">
            <FileCheck className="size-4 text-secondary shrink-0" />
            <p>
              {"Accès immédiat après achat, au format PDF numérique."}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}